import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";

const variantConfig = {
  information: {
    icon: InfoOutlined,
    backgroundColor: "#E8F4FD",
    borderColor: "#4A90D9",
    color: "#4A90D9",
  },
  warning: {
    icon: ReportProblemOutlined,
    backgroundColor: "#FEF4E8",
    borderColor: "#E89B3F",
    color: "#E89B3F",
  },
};

function AlertMessage({ variant, title, children, classes }) {
  const config = variantConfig[variant] || variantConfig.information;
  const IconComponent = config.icon;

  return (
    <div
      className={classes.container}
      style={{
        backgroundColor: config.backgroundColor,
        borderColor: config.borderColor,
      }}
    >
      <div className={classes.header}>
        <IconComponent
          className={classes.icon}
          style={{ color: config.color }}
        />
        <Typography
          variant="subtitle2"
          className={classes.title}
          style={{ color: config.color }}
        >
          {title}
        </Typography>
      </div>
      <Typography variant="body2" component="div" className={classes.body}>
        {children}
      </Typography>
    </div>
  );
}

const styles = () => ({
  container: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid",
    borderRadius: 8,
    padding: "14px 20px",
    marginTop: 16,
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: 6,
  },
  icon: {
    fontSize: 20,
    marginRight: 8,
  },
  title: {
    fontWeight: 600,
  },
  body: {
    marginLeft: 28,
    color: "#555",
    lineHeight: 1.6,
  },
});

export default withStyles(styles)(AlertMessage);
